import * as yup from 'yup';
import { DateUtil } from '../../../utils';

const employeePayload = {
  employeeId: 'AE0140',
  userId: 41,
  companyCode: '01',
};

const initialValues = {
  loanType: '',
  currency: '',
  loanAmt: null,
  loanPurpose: '',
  comments: '',
  payMode: '',
  loanInst: 0,
  loanInstAmt: 0,
  loanPayDate: '',
};

const validationSchema = yup.object().shape({
  loanType: yup.string().required('Loan Type is required'),
  currency: yup.string().required('Currency is required'),
  loanAmt: yup
    .number()
    .typeError('Loan Amount is required')
    .required('Loan Amount is required'),
  loanPurpose: yup.string().required('Loan Purpose is required'),
  comments: yup.string().notRequired(),
  payMode: yup.string().required('Payment Mode is required'),
  loanInst: yup
    .number()
    .typeError('Loan Installment must be a number')
    .required('Loan Installment is required')
    .positive('Loan Installment must be a positive number'),
  loanInstAmt: yup
    .number()
    .typeError('Loan Installment Amount must be a number')
    .required('Loan Installment Amount is required')
    .positive('Loan Installment Amount must be a positive number'),
  loanPayDate: yup
    .date()
    .required('Loan Payment Date is required')
    .typeError('Loan Payment Date must be a valid date'),
});

const populateLoanValues = (data, loanTypes, payModes) => {
  if (!data || typeof data !== 'object') return initialValues;
  const loanTypeCode = loanTypes?.find(
    item =>
      item.Description.toUpperCase().trim() ===
      data['Loan Type'].toUpperCase().trim(),
  );
  const loanType = loanTypeCode ? loanTypeCode?.Code : data['Loan Type'];
  const payModeCode = payModes?.find(
    item =>
      item.Description.toUpperCase().trim() ===
      data.PayMode.toUpperCase().trim(),
  );
  const payMode = payModeCode ? payModeCode?.Code : data?.PayMode;
  return {
    loanType: loanType || '',
    loanPurpose: data.Purpose?.toString().trim() || '',
    currency: data.Curr?.toString().trim() || '',
    loanAmt: parseFloat(data.Amount) || 0,
    loanInst: data.Installments || '',
    loanInstAmt: parseFloat(data.MonthAmt) || 0,
    loanPayDate:
      DateUtil.convertMonthYearToHtmlDate(data?.['Payment Date']) || '',
    payMode: payMode || '',
    comments:
      data.Comments?.toString().trim() === '-'
        ? ''
        : data.Comments?.toString().trim() || '',
  };
};

export { employeePayload, initialValues, validationSchema, populateLoanValues };
